<template>
  <div
    class="audit-radio-group"
    role="radiogroup"
  >
    <label
      v-for="(option, index) in values"
      :key="option[customValueKey]"
      class="audit-radio"
      :class="{ 'audit-radio--with-divider': hasDivider && index !== values.length - 1 }"
    >
      <input
        class="audit-radio__input"
        type="radio"
        :name="name"
        :value="option[customValueKey]"
        :checked="value === option[customValueKey]"
        @change="select(option[customValueKey])"
      />
      <span
        class="audit-radio__control"
        aria-hidden="true"
      />
      <span class="audit-radio__label">{{ option.label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    customValueKey: {
      type: String,
      default: "id"
    },
    hasDivider: Boolean,
    name: {
      type: String,
      default: "audit-radio"
    },
    value: {
      type: [Number, String],
      default: null
    },
    values: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    select(value) {
      this.$emit("update:value", value);
    }
  }
};
</script>

<style scoped>
.audit-radio-group {
  width: 100%;
}

.audit-radio {
  position: relative;
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-height: 19px;
  margin-bottom: 32px;
  cursor: pointer;
}

.audit-radio:last-child {
  margin-bottom: 0;
}

.audit-radio--with-divider::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: -16px;
  left: 30px;
  height: 1px;
  background: var(--colors-light-secondary-divider);
  opacity: 0.5;
}

.audit-radio__input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.audit-radio__control {
  display: flex;
  flex: 0 0 16px;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-top: 1px;
  margin-right: 14px;
  border: 1px solid var(--colors-light-primary-gray1);
  border-radius: 50%;
  background: var(--colors-light-neutral-white);
  box-sizing: border-box;
}

.audit-radio__control::after {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--colors-light-primary-gray1);
  opacity: 0;
}

.audit-radio__input:checked + .audit-radio__control::after {
  opacity: 1;
}

.audit-radio__label {
  flex: 1;
  color: var(--colors-light-primary-gray1);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
}
</style>
